import {
  Component,
  inject,
  Signal,
} from '@angular/core';
import { RoleService } from '../../../role/role.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-admin-products',
    templateUrl: './admin-products.component.html',
    styleUrls: ['./admin-products.component.scss', '../admin-main.common.scss'],
    standalone: false
})
export class AdminProductsComponent {

  private readonly roleService = inject(RoleService);

  public isAdmin = toSignal(this.roleService.can(null, 'admin'));

}
